
import Vue from 'vue'
import Component from 'vue-class-component'
import {Prop} from 'vue-property-decorator'

import ErrorHandler from '@/services/ErrorHandlerService'
import {INotificationService} from '@/services/NotificationService'
import UserService from '@/services/UserService'

import CardTitle from '../components/Atomic/CardTitle.vue'
import GreenButton from '../components/Atomic/GreenButton.vue'
import RedButton from '../components/Atomic/RedButton.vue'
import ProgressLinear from '@/components/Atomic/ProgressLinear.vue'
import {GenericUser} from '@/models/user'

@Component({
  components: {
    ProgressLinear,
    CardTitle,
    GreenButton,
    RedButton,
  },
})
export default class ChangeEmail extends Vue {
  private get hasSuggestions() {
    return this.suggestions.length > 0
  }

  @Prop(Function) public readonly saveEmail!: (
      chosenEmail: string,
      username: string,
  ) => void
  @Prop(Function) public readonly closeMailChange!: () => void
  @Prop() public readonly user!: GenericUser
  @Prop() public readonly ownEmail!: boolean
  private isLoading: boolean = false
  private confirmationDialog: boolean = false
  private isPending: boolean = false
  private suggestions: string[] = []
  private chosenEmail: string = ''
  private errorHandler = new ErrorHandler()
  private $notificationService!: INotificationService

  private created() {
    this.getSuggestions()
  }

  private async getSuggestions() {
    this.isLoading = true
    try {
      this.suggestions = await UserService.getMasksSuggestion(
          this.user.identifiant,
      )
      this.chosenEmail = this.suggestions[0]
      this.isLoading = false
    } catch {
      this.$notificationService.error(this.$t('CHANGEEMAIL.SuggestionError').toString())
    } finally {
      this.isLoading = false
    }
  }

  private cancel() {
    this.closeMailChange()
  }

  private cancelConfirmation() {
    this.confirmationDialog = false
  }

  private clearData() {
    this.chosenEmail = ''
    this.suggestions = []
  }

  private async save() {
    if (this.chosenEmail) {
      try {
        this.isPending = true
        this.isLoading = true
        await this.saveEmail(this.chosenEmail, this.user.identifiant)
        this.$notificationService.success(
            this.$t('HOME.ChangeEmailSuccess').toString(),
        )
        this.closeMailChange()
      } catch (error: any) {
        this.errorHandler.handle(this, error.response.data.code, true)
        this.isPending = false
        this.isLoading = false
      }
    }
  }

  private selectEmail(email: string) {
    this.chosenEmail = email
  }
}
